import { useIntl } from 'react-intl';
import { IconCustomAurora } from '@rossum/ui/icons/tabler';
import { Badge, IconButton, SvgIcon, Tooltip } from '@rossum/ui/material';
import { ChatPanel } from './ChatPanel';
import {
  isStreamingStatus,
  useChatClientState,
  useChatStore,
  useUnseenChatIds,
} from './hooks/chatStore';
import { useAgentUpdateToast } from './hooks/useAgentUpdateToast';
import { spin } from './shared/chatAnimations';

export const ChatWidget = () => {
  const intl = useIntl();
  const isOpen = useChatStore(s => s.isOpen);
  const setIsOpen = useChatStore(s => s.setIsOpen);

  const chatId = useChatStore(s => s.drawerChatId);
  const { status } = useChatClientState(chatId);
  const isActiveStreaming = isStreamingStatus(status);
  const unseenCount = useUnseenChatIds().size;

  useAgentUpdateToast();

  return (
    <>
      <Tooltip
        title={intl.formatMessage({ id: 'features.chat.widget.tooltip' })}
      >
        <IconButton
          aria-label={intl.formatMessage({
            id: 'features.chat.widget.openLabel',
          })}
          data-cy="chat-open-button"
          onClick={() => setIsOpen(true)}
        >
          <Badge
            badgeContent={unseenCount}
            color="warning"
            data-cy="chat-unseen-badge"
          >
            <SvgIcon
              sx={{
                color: 'aurora.main',
                animation: isActiveStreaming
                  ? `${spin} 1.5s ease-in-out infinite`
                  : 'none',
              }}
            >
              <IconCustomAurora />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      <ChatPanel open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
